import * as React from 'react'

interface RecaptchaInstance {
  ready: Function
  execute: Function
  render: Function
}

declare global {
  interface Window {
    grecaptcha: RecaptchaInstance
  }
}

const recaptchaSiteKey = process.env.GATSBY_RECAPTCHA_SITE_KEY || ''
const recaptchaId = 'recaptcha-container'

export const Recaptcha = ({ }) => {
  const [recaptchaResponse, setRecaptchaResponse] = React.useState('')

  React.useEffect(() => {
    const existingScript = document.getElementById('recaptcha-script')

    if (!existingScript) {
      const script = document.createElement('script')

      script.src = `https://www.google.com/recaptcha/api.js`
      script.id = 'recaptcha-script'
      script.addEventListener('load', () => {
        window.grecaptcha.ready(async () => {
          window.grecaptcha.render(recaptchaId, {
            sitekey: recaptchaSiteKey,
            callback: setRecaptchaResponse,
          })
        })
      })

      document.body.appendChild(script)
    } else {
      window?.grecaptcha?.render(recaptchaId, {
        sitekey: recaptchaSiteKey,
        callback: setRecaptchaResponse,
      })
    }
  }, [])

  return (
    <>
      <input type="hidden" name="grecaptcha" value={recaptchaResponse} />
      <div id={recaptchaId}></div>
    </>
  )
}
